import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`aiOrder/findList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportData({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`aiOrder/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


}
